import type { Path } from '@cobliteam/api-lib/src/__generated__/graphql';
import { Typography } from '@cobliteam/ui/components';
import Icon from '@cobliteam/ui/icons';
import { format } from '@cobliteam/utils/date';

interface PathDetailsDialogSummaryProps {
  path: Path;
}

const PathDetailsDialogSummary = ({ path }: PathDetailsDialogSummaryProps) => {
  const { startTime, endTime, vehicle } = path;

  const startDate = format(startTime, 'dd/MM/yyyy, HH:mm');
  const endDate = format(endTime, 'HH:mm');
  const vehicleLicensePlate = vehicle?.licensePlate;

  return (
    <div className='flex items-center gap-4'>
      <div className='flex items-center gap-2'>
        <Icon name='calendar-days' />
        <Typography variant='body' color='secondary'>
          {startDate} - {endDate}
        </Typography>
      </div>
      <div className='flex items-center gap-2'>
        <Icon name='car-front' />
        <Typography variant='body' color='secondary'>
          {vehicleLicensePlate || '-'}
        </Typography>
      </div>

      <div className='flex items-center gap-2'>
        <Icon name='cb-filters-vehicle-group-cb' />
        <Typography variant='body' color='secondary' className='line-clamp-1'>
          {vehicle?.groups?.map((group) => group.name).join(', ') || 'Sem grupo'}
        </Typography>
      </div>
    </div>
  );
};

export default PathDetailsDialogSummary;
